import { TypedPolicy } from '@/react/portainer/policies/types';
import { useDockerSecurityInitialValues } from '@/react/portainer/policies/components/docker/security/useDockerSecurityInitialValues';

import { FormSection } from '@@/form-components/FormSection';

import { SettingItem } from './SettingItem';

interface Props {
  policy: TypedPolicy<unknown>;
}

export function DockerSecurityPolicyReadOnly({ policy }: Props) {
  const values = useDockerSecurityInitialValues(policy);

  return (
    <FormSection title="Docker security settings">
      <div className="overflow-hidden rounded-lg border border-gray-5 th-dark:border-gray-7">
        <SettingItem
          label="Hide bind mounts for non-administrators"
          value={!values.allowBindMountsForRegularUsers}
        />
        <SettingItem
          label="Hide privileged mode for non-administrators"
          value={!values.allowPrivilegedModeForRegularUsers}
        />
        <SettingItem
          label="Hide the use of host PID 1 for non-administrators"
          value={!values.allowHostNamespaceForRegularUsers}
        />
        <SettingItem
          label="Hide the use of Stacks for non-administrators"
          value={!values.allowStackManagementForRegularUsers}
        />
        <SettingItem
          label="Hide device mappings for non-administrators"
          value={!values.allowDeviceMappingForRegularUsers}
        />
        <SettingItem
          label="Hide container capabilities for non-administrators"
          value={!values.allowContainerCapabilitiesForRegularUsers}
        />
        <SettingItem
          label="Hide sysctl settings for non-administrators"
          value={!values.allowSysctlSettingForRegularUsers}
        />
        <SettingItem
          label="Hide security-opt for non-administrators"
          value={!values.allowSecurityOptForRegularUsers}
        />
      </div>
    </FormSection>
  );
}
